module.exports = __webpack_public_path__ + "img/preise-regional.6c3e495.webp";